import {Component, inject, Input} from '@angular/core';
import {BaseComponent} from "../../../BaseComponent";
import {UserMetricInstance} from "../../../../models/user/Metric/UserMetricInstance";
import {DashboardService} from "../../../../services/dashboard/dashboard.service";

@Component({
  selector: 'app-secondary-measure-card',
  templateUrl: './secondary-measure-card.component.html',
  styleUrls: ['./secondary-measure-card.component.css', '../measure-cards.component.css']
})
export class SecondaryMeasureCardComponent extends BaseComponent {
  @Input() card!: UserMetricInstance;
  protected dashboardService: DashboardService = inject(DashboardService);

}
